/** Shell-side sticker id → image asset src. Presentation only — never enters
 *  the SourcePack/scoring graph or core's AssetManifest. Art overrides the
 *  procedural fallback in the catalog when a sticker id has an entry here. */
export const STICKER_ART: Record<string, string> = {
  "sticker-fire": "/assets/stickers/sticker-fire.svg",
  "sticker-skull": "/assets/stickers/sticker-skull.svg",
  "sticker-eyes": "/assets/stickers/sticker-eyes.svg",
  "sticker-hundred": "/assets/stickers/sticker-hundred.svg",
  "sticker-sob": "/assets/stickers/sticker-sob.svg",
  "sticker-heart": "/assets/stickers/sticker-heart.svg",
  "sticker-clown": "/assets/stickers/sticker-clown.svg",
  "sticker-alien": "/assets/stickers/sticker-alien.svg",
  "sticker-sunglasses": "/assets/stickers/sticker-sunglasses.svg",
  "sticker-tophat": "/assets/stickers/sticker-tophat.svg",
  "sticker-partyhat": "/assets/stickers/sticker-partyhat.svg",
  "sticker-crown": "/assets/stickers/sticker-crown.svg",
  "sticker-star": "/assets/stickers/sticker-star.svg",
  "sticker-arrow": "/assets/stickers/sticker-arrow.svg",
  "sticker-shock": "/assets/stickers/sticker-shock.svg",
  "sticker-joy": "/assets/stickers/sticker-joy.svg",
  "sticker-siren": "/assets/stickers/sticker-siren.svg",
  "sticker-speech": "/assets/stickers/sticker-speech.svg",
  "sticker-ring": "/assets/stickers/sticker-ring.svg",
  "sticker-censor": "/assets/stickers/sticker-censor.svg",
};

export function stickerArtSrc(stickerId: string | null | undefined): string | undefined {
  return stickerId ? STICKER_ART[stickerId] : undefined;
}
